import services from 'core/services';
import { store } from 'store';

const { logout: logoutDispatch } = services;

export const logout = () => {
  const { isloggedIn } = store.getState().authorization;
  if (!isloggedIn) return;
  logoutDispatch();
};
